{
  "name": "@safaricom-mxl/node",
  "version": "0.1.88",
  "private": false,
  "description": "Safaricom MXL NodeJS wrapper around OpenTelemetry APIs",
  "author": "Francis Masha <fkonde@safaricom.co.ke>",
  "license": "MIT",
  "sideEffects": false,
  "type": "module",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/types/index.d.ts",
        "default": "./dist/node/index.js"
      },
      "node": {
        "types": "./dist/types/index.d.ts",
        "default": "./dist/node/index.js"
      },
      "types": "./dist/types/index.d.ts",
      "default": "./dist/node/index.js"
    }
  },
  "types": "./dist/types/index.d.ts",
  "files": [
    "dist",
    "LICENSE"
  ],
  "engines": {
    "node": ">=18"
  },
  "publishConfig": {
    "access": "public"
  },
  "bin": {
    "opentelemetry-instrument": "dist/bin/opentelemetry-instrument.js"
  },
  "scripts": {
    "clean": "git clean -xdf .turbo node_modules coverage dist tmp",
    "prebuild": "rimraf coverage dist tmp",
    "build": "pnpm tsx build.ts && pnpm build-types",
    "build-only": "pnpm tsx build.ts",
    "build-types": "tsc --noEmit false --declaration --emitDeclarationOnly --resolveJsonModule --moduleResolution bundler --module preserve --stripInternal --declarationDir dist/types src/index.ts",
    "check-exports": "attw --pack .",
    "format": "biome format .",
    "lint": "biome check .",
    "typecheck": "tsc --noEmit",
    "prepublishOnly": "pnpm build",
    "type-check": "tsc --noEmit",
    "unit-test": "MXL_STARTUP_LOGS=false vitest --run",
    "unit-test-coverage": "MXL_STARTUP_LOGS=false vitest --run --coverage",
    "unit-test-watch": "vitest"
  },
  "dependencies": {
    "@opentelemetry/api": "^1.9.0",
    "@opentelemetry/api-logs": "^0.208.0",
    "@opentelemetry/auto-instrumentations-node": "^0.67.1",
    "@opentelemetry/core": "^2.2.0",
    "@opentelemetry/exporter-jaeger": "^2.2.0",
    "@opentelemetry/exporter-logs-otlp-http": "^0.208.0",
    "@opentelemetry/exporter-metrics-otlp-proto": "^0.208.0",
    "@opentelemetry/exporter-trace-otlp-proto": "^0.208.0",
    "@opentelemetry/instrumentation": "^0.208.0",
    "@opentelemetry/instrumentation-http": "0.208.0",
    "@opentelemetry/instrumentation-runtime-node": "^0.22.0",
    "@opentelemetry/instrumentation-winston": "^0.53.0",
    "@opentelemetry/resources": "^2.2.0",
    "@opentelemetry/sdk-logs": "^0.208.0",
    "@opentelemetry/sdk-metrics": "^2.2.0",
    "@opentelemetry/sdk-node": "^0.208.0",
    "@opentelemetry/sdk-trace-base": "^2.2.0",
    "@opentelemetry/semantic-conventions": "^1.38.0",
    "@opentelemetry/winston-transport": "^0.19.0",
    "@safaricom-mxl/core": "workspace:*",
    "@safaricom-mxl/node-exception": "workspace:*",
    "chalk": "^5.6.2",
    "cli-spinners": "^3.3.0",
    "flat": "^6.0.1",
    "import-in-the-middle": "^2.0.0",
    "json-stringify-safe": "^5.0.1",
    "ora": "^9.0.0",
    "pino-abstract-transport": "^3.0.0",
    "require-in-the-middle": "^8.0.1",
    "semver": "^7.7.3",
    "tslib": "^2.8.1",
    "winston-transport": "^4.9.0"
  },
  "devDependencies": {
    "@arethetypeswrong/cli": "^0.18.2",
    "@biomejs/biome": "^2.3.7",
    "@types/json-stringify-safe": "^5.0.3",
    "@types/node": "^24.10.1",
    "@types/semver": "^7.7.1",
    "@vitest/coverage-v8": "^4.0.13",
    "rimraf": "^6.1.2",
    "tsup": "^8.5.1",
    "typescript": "^5.9.3",
    "vite-tsconfig-paths": "^5.1.4",
    "vitest": "^4.0.13",
    "winston": "^3.18.3"
  },
  "peerDependencies": {
    "@trpc/server": "^10.0.0 || ^11.0.0",
    "import-in-the-middle": "^2.0.0",
    "require-in-the-middle": "^8.0.1"
  },
  "overrides": {
    "@opentelemetry/winston-transport": "^0.50.0"
  }
}
